var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastBackwardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 30,
    viewBox: "0 0 61 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2954 17.1651C33.6287 16.2028 33.6287 13.7972 35.2954 12.8349L48.7954 5.0407C50.4621 4.07846 52.5454 5.28127 52.5454 7.20577L52.5454 22.7942C52.5454 24.7187 50.4621 25.9215 48.7954 24.9593L35.2954 17.1651Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0229 17.1651C18.3563 16.2028 18.3563 13.7972 20.0229 12.8349L33.523 5.0407C35.1896 4.07846 37.2729 5.28127 37.2729 7.20577L37.2729 22.7942C37.2729 24.7187 35.1896 25.9215 33.5229 24.9593L20.0229 17.1651Z",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 17.1651C3.08333 16.2028 3.08333 13.7972 4.75 12.8349L18.25 5.0407C19.9167 4.07846 22 5.28127 22 7.20577L22 22.7942C22 24.7187 19.9167 25.9215 18.25 24.9593L4.75 17.1651Z",
    fill: "black",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastBackwardIcon);
export default __webpack_public_path__ + "static/media/fast-backward-icon.1cb00a1733ac6f0214f607d9eec157e6.svg";
export { ForwardRef as ReactComponent };